define('Plans.ei1.PlansPage', [
    'Plans.ei1.PlansPage.View'
], function (
    PlansPageView
) {
    'use strict';

    return {
        mountToApp: function (container) {
            var PageType = container.getComponent('PageType');

            // Create a subclass that bakes `container` into every instance
            var BoundView = PlansPageView.extend({
                initialize: function (options) {
                    options = options || {};
                    options.container = container;  
                    PlansPageView.prototype.initialize.call(this, options);
                }
            });

            PageType.registerPageType({
                name: 'plans_page',
                routes: ['plans', 'plans/:passtype'],
                view: BoundView,                   
                defaultTemplate: {
                    name: 'plans_page.tpl',
                    displayName: 'Plans Page'
                }
            });
        }
    }
});
